import React from 'react';
import styled from 'styled-components';
import {
  Avatar,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import { People as PeopleIcon } from '@material-ui/icons';

import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import WrappedTableCell from '../../../common/WrappedTableCell';
import { BaseSignupCardProps } from '../../../login/Signup.interface';

const StyledCard = styled(Card)`
  &.has-users .card-content {
    padding: 0;
  }
  .avatar-cell {
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 4px;
    .avatar {
      width: 32px;
      height: 32px;
      font-size: 16px;
    }
  }
`;

const SignupInviteUsersCard: React.FC<BaseSignupCardProps> = props => {
  const { signup } = props;
  const hasUsers = signup.users.length > 0;
  return (
    <StyledCard className={hasUsers ? 'has-users' : undefined}>
      <CardTitle>
        <PeopleIcon />
        Invite Users
      </CardTitle>
      <CardContent padding='large' className='card-content'>
        {hasUsers ? (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: 0 }} />
                  <TableCell>Employee</TableCell>
                  <TableCell>Functional Role</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {signup.users.map((user, index) => (
                  <TableRow key={`${user.email}-${index}`}>
                    <TableCell className='avatar-cell'>
                      <Avatar className='avatar'>
                        {user.firstName
                          .slice(0, 1)
                          .concat(user.lastName.slice(0, 1))
                          .toUpperCase()}
                      </Avatar>
                    </TableCell>
                    <WrappedTableCell>
                      {user.firstName} {user.lastName} ({user.email})
                    </WrappedTableCell>
                    <WrappedTableCell>{user.role}</WrappedTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography variant='body2' color='textSecondary'>
            No users invited.
          </Typography>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default SignupInviteUsersCard;
